{
  "94ea9b1d33a02975": "Mostrar menos",
  "a58558effdc5d28c": "Esto se mostrará a los profesionales antes de que reserven este turno.",
  "b7c0d007120b9767": "Editar nota de turno",
  "e7ca563e7ef6c518": "Nota de turno",
  "f5c9bd131486e793": "Mostrar más"
}
